import { styled, Box } from '@mui/material';
import { Row } from 'components/Layout';
import useSidebarMenuItems from 'hooks/ui/useSidebarMenuItems';
import Navigation from './Navigation';
import PerfectScrollbar from 'react-perfect-scrollbar';
import EnvironmentFlag from './EnvironmentFlag';
import UserProfile from './UserProfile';
import OrganisationSwitcher from './OrganisationSwitcher';
import useCurrentUser from 'hooks/data/currentUser/useCurrentUser';

const Logo = styled('img')({
  height: '24px',
});

const Wrapper = styled(Box)(({ theme }) => ({
  paddingRight: theme.spacing(theme.spacingSizes.sm),
}));

const Container = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(theme.spacingSizes.lg),
}));

const Scrollbar = styled(PerfectScrollbar)({
  transition: 'all 0.3s ease',
});

const SidebarContent: React.FC = () => {
  const { profile } = useCurrentUser();
  const realm = profile.data?.realm;

  const menuItems = useSidebarMenuItems(realm);

  return (
    <Container>
      <Wrapper>
        <Row centered justify="space-between">
          <Logo src="images/logo.png" alt="Further logo" />
          <EnvironmentFlag />
        </Row>
      </Wrapper>
      <Wrapper>
        <OrganisationSwitcher
          currentOrganisation={profile.data?.firm}
          otherOrganisations={profile.data?.otherOrgs ?? []}
          currentRealm={profile.data?.realm}
        />
      </Wrapper>
      <Scrollbar>
        <Wrapper>
          <Navigation menuItems={menuItems ?? []} />
        </Wrapper>
      </Scrollbar>
      <Wrapper>
        <UserProfile user={profile.data} />
      </Wrapper>
    </Container>
  );
};

export default SidebarContent;
